// Generated from src/locales/lang/zh.js.
export default {
  "请输入手机号或用户名": "請輸入手機號碼或使用者名",
  "请输入密码": "請輸入密碼",
  "自动登录": "自動登入",
  "游戏试玩": "遊戲試玩",
  "忘记密码": "忘記密碼",
  "登录账户": "登入帳戶",
  "联系客服": "聯絡客服",
  "注册账户": "註冊帳戶",
  "请选择你的语言": "請選擇你的語言",
  "选择你的语言": "Choose your language",
  "英语": "English",
  "简体中文": "簡體中文",
  "繁体中文": "繁體中文",
  "请输入确认密码": "請輸入確認密碼",
  "推荐人": "推薦人",
  "请输入验证码": "請輸入驗證碼",
  "注册": "註冊",
  "登录": "登入",
  "返回登录": "返回登入",
  "复制成功": "複製成功",
  "客服": "客服",
  "大厅": "大廳",
  "发现": "發現",
  "优惠": "優惠",
  "我的": "我的",
  "会话": "會話",
  "公告通知": "公告通知",
  "上下分如有问题请及时联系客服": "上下分如有問題請及時聯絡客服",
  "在线客服": "網路客服",
  "提供各类问题疑难排解": "提供各類問題疑難排解",
  "Telegram客服": "Telegram客服",
  "Signal客服": "Signal客服",
  "Signal客服号码": "+1(971) 427 1149",
  "消息中心": "訊息中心",
  "公告": "公告",
  "站内信": "站內信",
  "没有更多了": "沒有更多了",
  "请先登录或者注册": "請先登入或註冊",
  "充值": "儲值",
  "转账": "轉帳",
  "提现": "提現",
  "IOS用户注意": "iOS用戶注意",
  "尊敬的U8会员您好": "尊敬的U8會員您好",
  "系统内容1": "U8國際iOS新版APP已完成修復並正式上線，現已開放下載。",
  "系统内容2": "但為確保永久訪問穩定，建議您優先使用Safari瀏覽器打開",
  "系统内容3": "點選底部 📤“分享”按鈕 → 選擇 “新增至主畫面”，即可快速進入平台。",
  "系统内容4": "如欲使用APP，請前往官網",
  "系统内容5": "首頁，點選右上角【點選下載】按鈕取得最新版。",
  "系统内容6": "如有疑問，請聯絡官方客服",
  "系统内容7": "協助處理。",
  "系统内容8": "感謝您的支持與體諒！",
  "系统内容9": "U8國際營運團隊",
  "公平": "公平",
  "公正": "公正",
  "公开": "公開",
  "官方投注机器人": "官方投注機器人",
  "系统内容10": "直接進行遊戲、儲值、提現等操作。",
  "搜索": "搜尋",
  "系统内容11": "感謝您的體諒與支持，祝您遊戲愉快！",
  "今日不再弹出": "今日不再彈出",
  "添加": "添加",
  "到手机主页屏幕": "到手機主頁螢幕",
  "选择分享按钮": "到手機主頁螢幕",
  "点击": "點選",
  "加至主画面": "加至主畫面",
  "点击「加入」按钮": "點擊“加入”按鈕",
  "存款": "存款",
  "网银转账": "網路銀轉帳",
  "微信": "微信",
  "支付宝": "支付寶",
  "收款账号": "收款帳號",
  "复制": "複製",
  "银行户名": "銀行戶名",
  "开户行": "開戶行",
  "银行地址": "銀行地址",
  "开户银行": "開戶銀行",
  "选择开户银行": "選擇開戶銀行",
  "存款人姓名": "存款人姓名",
  "请输入存款人姓名": "請輸入存款人姓名",
  "请务必输入正确的存款人姓名": "為及時到賬，請務必輸入正確的存款人姓名",
  "银行卡号": "金融卡號",
  "请输入银行卡号": "請輸入銀行卡號",
  "开户行地址": "開戶行地址",
  "请输入开户行地址": "請輸入開戶行位址",
  "请输入银行开户行地址": "請輸入銀行開戶行地址",
  "存款金额": "存款金額",
  "请输入取款金额": "請輸入提款金額",
  "元": "元",
  "USDT价格稳定": "USDT價格穩定",
  "流通性高": "流通性高",
  "不受监管": "不受監管",
  "了解更多": "了解更多",
  "绑定协议地址": "綁定協定位址",
  "交易所划转": "交易所劃轉",
  "完成取款": "完成提款",
  "钱包协议": "錢包協議",
  "温馨提示": "溫馨提示",
  "温馨提示内容": "請選擇正確的USDT協議付款，若您選擇錯誤的協議付款，平台將無法收到您的付款，為此我們不承擔任何負責！",
  "立即存款": "立即存款",
  "存款遇到问题": "存款遇到問題",
  "联系": "聯繫",
  "人工客服": "人工客服",
  "解决": "解決",
  "银行类型": "銀行類型",
  "请输入银行类型": "請輸入銀行類型",
  "请输入金额区间": "請輸入金額在{min_price}-{max_price}之間！",
  "等待后台审核": "提交成功，等待後台審核",
  "场馆转账": "場館轉帳",
  "余额自动转入": "餘額自動轉入",
  "启用后余额自动转入转出游戏场馆": "啟用後餘額自動轉入轉出遊戲場館",
  "请输入转账金额": "請輸入轉帳金額",
  "全部转入": "全部轉入",
  "可转账金额": "可轉帳金額",
  "确认转账": "確認轉帳",
  "场馆余额明细": "場館餘額明細",
  "点击查看全部场馆余额": "點擊查看全部場館餘額",
  "主钱包": "主錢包",
  "一键取回": "一鍵取回",
  "收起": "收起",
  "展开": "展開",
  "请输入操作金额": "請輸入操作金額",
  "场馆内钱包不支持互转": "場館內錢包不支援互轉",
  "操作成功": "操作成功",
  "VIP特权": "VIP特權",
  "已达标": "已達標",
  "未达标": "未達標",
  "累计存款": "累計存款",
  "流水要求": "流水要求",
  "VIP最高返水比例": "VIP最高返水比例",
  "VIP等级": "VIP等級",
  "真人": "真人",
  "体育": "體育",
  "电竞": "電競",
  "棋牌": "棋牌",
  "电子": "電子",
  "彩票": "抽籤",
  "活动规则": "活動規則",
  "晋升标准": "晉升標準",
  "规则内容1": "會員的累計存款以及累計流水達到相應等級的要求，即可在隔天24點前晉級相應VIP等級。",
  "晋升顺序": "晉升順序",
  "规则内容2": "VIP等級達到相應的要求可每天晉升一級，但VIP等級不可越級晉升。",
  "保级要求": "保級要求",
  "规则内容3": "會員在達到某VIP等級後，90天內投注需要完成保級流水要求。如果在此期間完成晉升，保級要求重新按照目前等級計算。",
  "降级标准": "降級標準",
  "规则内容4": "如果會員在一個季度（90天計算）內沒有完成相應的保級要求流水，系統會自動降級一個等級，相應的返水及其它優惠也會隨之調整至降級後的等級。",
  "VIP返水": "VIP回水",
  "规则内容5": "VIP返水優惠發放金額根據會員當天北京時間00:00—23:59之間的有效投注進行計算，當天所有的投注額返水將在註單結算當天結束後24小時內發放到福利中心，進入個人中心點擊福利中心進行手動領取。 （VIP返水1倍流水即可提款）",
  "规则内容6": "歐寶娛樂保留對活動的修改，停止及最終解釋權",
  "取款": "提款",
  "银行卡取款": "金融卡提款",
  "钱包金额": "錢包金額",
  "一键回收": "一鍵回收",
  "中心钱包": "中心錢包",
  "游戏钱包": "遊戲錢包",
  "选择USDT地址": "選擇USDT地址",
  "请选择USDT地址": "請選擇USDT地址",
  "添加USDT地址": "新增USDT地址",
  "打码量": "打碼量",
  "取款金额": "提款金額",
  "最大金额": "最大金額",
  "支付密码": "支付密碼",
  "请输入支付密码": "請輸入支付密碼",
  "每笔手续费": "每筆手續費",
  "折合USDT": "折合USDT",
  "参考汇率": "參考匯率",
  "实时变化": "即時變化",
  "实际到账": "實際到帳",
  "选择银行卡": "選擇銀行卡",
  "请选择银行卡": "請選擇銀行卡",
  "添加银行卡": "新增銀行卡",
  "立即取款": "立即提款",
  "取款遇到问题": "提款遇到問題",
  "真实姓名": "真實姓名",
  "绑定真实姓名后不可修改": "綁定真實姓名後不可修改",
  "确认修改": "確認修改",
  "请选择您要提现到的银行卡": "請選擇您要提現到的銀行卡",
  "单笔取款不能低于100元": "單筆提款不能低於100元",
  "请输入您的支付密码": "請輸入您的支付密碼",
  "请填写用户实名信息": "請填寫用戶實名資訊",
  "提交成功": "提交成功",
  "优惠活动": "優惠活動",
  "全部优惠": "全部優惠",
  "限时活动": "限時活動",
  "新人首存": "新人首存",
  "日常活动": "日常活動",
  "暂未设置签名": "暫未設定簽名",
  "账户总资产": "帳戶總資產",
  "我的钱包": "我的錢包",
  "账户明细": "帳戶明細",
  "投注记录": "投注記錄",
  "安全设置": "安全設定",
  "我的等级": "我的等級",
  "VIP中心": "VIP中心",
  "邀请好友": "邀請好友",
  "推荐送礼金": "推薦送禮金",
  "官方公告": "官方公告",
  "坐收盈利": "坐收營利",
  "合营计划": "合營計劃",
  "加入我们": "加入我們",
  "月入百万": "月入百萬",
  "NG扑克": "NG撲克",
  "活动中心": "活動中心",
  "平台优惠回馈活动": "平台優惠回饋活動",
  "输赢比例": "輸贏比例",
  "功能设置": "功能設定",
  "反水比例": "反水比例",
  "反水中心": "反水中心",
  "修改登录密码": "修改登入密碼",
  "个人资料": "個人資料",
  "个人头像": "個人頭像",
  "用户名": "使用者名稱",
  "请输入用户名": "請輸入使用者名稱",
  "请输入真实姓名": "請輸入真實姓名",
  "出生日期": "出生日期",
  "请选择出入日期": "請選擇出入日期",
  "手机号码": "手機號碼",
  "绑定手机号保障账号安全": "綁定手機號，保障帳號安全",
  "电子邮箱": "電子郵件信箱",
  "绑定邮箱保护账号安全": "綁定郵箱保護帳號安全",
  "请输入正确手机号": "請輸入正確手機號",
  "请输入正确邮箱号": "請輸入正確信箱號碼",
  "请输入正确的日期格式": "請輸入正確的日期格式",
  "邀请链接": "邀請連結",
  "立即邀请": "立即邀請",
  "礼金介绍": "禮金介紹",
  "明细记录": "明細記錄",
  "下级概览": "下級概覽",
  "下级成员统计": "下級成員統計",
  "本月新增": "本月新增",
  "本月活跃成员": "本月活躍成員",
  "本月有效活跃": "本月有效活躍",
  "今日新增": "今日新增",
  "今日活跃": "今日活躍",
  "本月新增有效会员": "本月新增有效會員",
  "今日存款": "今日存款",
  "数据列表": "數據列表",
  "礼金记录": "禮金記錄",
  "好友明细": "好友明細",
  "重置": "重置",
  "查询": "查詢",
  "日期": "日期",
  "礼金": "禮金",
  "备注": "備註",
  "保存链接": "儲存連結",
  "保存图片": "保存圖片",
  "保存二维码": "儲存二維碼",
  "取消": "取消",
  "链接已复制到剪贴板": "連結已複製到剪貼簿",
  "复制链接失败": "複製連結失敗",
  "合营部": "合營部",
  "立即咨询": "立即諮詢",
  "咨询": "諮詢",
  "联系方式": "聯絡方式",
  "请输入您的联系方式": "請輸入您的聯絡方式",
  "申请理由": "申請理由",
  "请输入申请理由": "請輸入申請理由",
  "盈利总额": "獲利總額",
  "充值总额": "儲值總額",
  "提现总额": "提現總額",
  "投注总额": "投注總額",
  "设置": "設定",
  "消息时间显示": "訊息時間顯示",
  "中奖提示": "中獎提示",
  "安静模式": "安靜模式",
  "关于CG": "關於CG",
  "帮助与反馈": "幫助與回饋",
  "退出": "退出",
  "返水比例": "返水比例",
  "当日累计投注": "當日累計投注",
  "转运金": "轉運金",
  "开元棋牌": "開元棋牌",
  "设置提现密码": "設定提現密碼",
  "原密码": "原密碼",
  "请输入当前密码": "請輸入目前密碼",
  "新密码": "新密碼",
  "请输入新密码": "請輸入新密碼",
  "确认新密码": "確認新密碼",
  "请再次输入密码": "請再次輸入密碼",
  "请输入旧密码": "請輸入舊密碼",
  "请输入正确的旧密码长度": "請輸入正確的舊密碼長度",
  "请输入正确的新密码长度": "請輸入正確的新密碼長度",
  "两次密码不一致": "兩次密碼不一致",
  "新旧密码不能一致": "新舊密碼不能一致",
  "密码修改成功": "密碼修改成功",
  "app下载": "app下載",
  "可扫描下发二维码进行app下载": "可掃描下發二維碼進行app下載",
  "立即下载": "立即下載",
  "下载说明": "需在同一網路環境下載安裝註冊，請勿切換網路； 若無法正常安裝，請使用手機自備瀏覽器開啟本頁面",
  "请输入金额": "請輸入金額",
  "转入": "轉入",
  "平台钱包": "平台錢包",
  "操作金额不能为0": "操作金額不能為0",
  "转入成功": "轉入成功",
  "天": "天",
  "时": "時",
  "分": "分",
  "秒": "秒",
  "剩余领取次数": "剩餘領取次數",
  "次": "次",
  "主账号余额": "主帳號餘額",
  "账户充值": "帳戶儲值",
  "账户提现": "帳戶提現",
  "下线转账": "下線轉帳",
  "订单号": "訂單編號",
  "金额": "金額",
  "空空如也": "空空如也",
  "今日": "今日",
  "近7日": "近7日",
  "近15日": "近15日",
  "近30日": "近30日",
  "转出": "轉出",
  "赠送": "贈送",
  "反水": "反水",
  "未定义": "未定義",
  "待审核": "待審核",
  "审核通过": "審核通過",
  "审核拒绝": "審核拒絕",
  "失败": "失敗",
  "成功": "成功",
  "待结算": "待結算",
  "全平台": "全平台",
  "大舞台": "大舞台",
  "官方动态": "官方動態",
  "动态": "動態",
  "活动申请记录": "活動申請記錄",
  "活动标题": "活動標題",
  "申请时间": "申請時間",
  "状态": "狀態",
  "未约定": "未約定",
  "通过": "透過",
  "拒绝": "拒絕",
  "派彩": "派彩",
  "无效注单": "無效注單",
  "已结算": "已結算",
  "未结算": "未結算",
  "返水中心": "返水中心",
  "返水记录": "返水記錄",
  "点击领取": "點擊領取",
  "累计领取": "累計領取",
  "待领取": "待領取",
  "返水金额": "返水金額",
  "返水时间": "返水時間",
  "领取时间": "領取時間",
  "暂未领取": "暫未領取",
  "暂无领取额度": "暫無領取額度",
  "加载中": "載入中",
  "最多支持添加5个地址": "最多支援新增5個地址",
  "认证失败": "認證失敗",
  "您的账号登陆过期，请重新登陆": "您的帳號登陸過期，請重新登陸",
  "提示": "提示",
  "您确定要退出登录吗": "您確定要登出登入嗎",
  "精彩内容等你来体验，快来登录吧": "精彩內容等你來體驗，快來登入吧",
  "立即下载APP": "立即下載APP",
  "余额": "餘額",
  "活动详情": "活動詳情",
  "活动说明": "活動說明",
  "立即申请": "立即申請",
  "前往登录": "前往登入",
  "代理系统": "代理系統",
  "下属代理": "下屬代理",
  "代理总览": "代理總覽",
  "直属玩家": "直屬玩家",
  "盈亏统计": "盈虧統計",
  "账单查询": "帳單查詢",
  "充值记录": "儲值記錄",
  "提现记录": "提現記錄",
  "个人信息": "個人資訊",
  "下级在线": "下級在線",
  "我的余额": "我的餘額",
  "附属代理人": "附屬代理人",
  "附属玩家": "附屬玩家",
  "今日投注": "今日投注",
  "今日收入": "今日收入",
  "历史收入": "歷史收入",
  "邀请码": "邀請碼",
  "开盘中": "開盤中",
  "已封盘": "已封盤",
  "下注倒计时": "下注倒數計時",
  "期": "期",
  "期开奖结果": "期開獎結果",
  "已开启": "已開啟",
  "已关闭": "已關閉",
  "期号": "期號",
  "号码": "號碼",
  "总和": "總和",
  "总和两面": "總和兩面",
  "首页": "首頁",
  "上一页": "上一頁",
  "下一页": "下一頁",
  "尾页": "尾頁",
  "请输入": "請輸入",
  "下注": "下注",
  "选择": "選擇",
  "大小单双": "大小單雙",
  "大": "大",
  "小": "小",
  "单": "單",
  "双": "雙",
  "大单": "大單",
  "大双": "大雙",
  "小单": "小單",
  "小双": "小雙",
  "形态": "形態",
  "豹子": "豹子",
  "对子": "對子",
  "顺子": "順子",
  "极大": "極大",
  "极小": "極小",
  "特码": "特碼",
  "清空": "清空",
  "立即下注": "立即下注",
  "开奖号码": "開獎號碼",
  "第": "第",
  "投注时间": "投注時間",
  "投注金额": "投注金額",
  "玩法": "玩法",
  "盘类": "磁碟類",
  "派奖奖金": "派獎獎金",
  "赔率": "賠率",
  "双面玩法": "雙面玩法",
  "特码玩法": "特碼玩法",
  "倍": "倍",
  "投注积分": "投注積分",
  "请输入投注积分": "請輸入投注積分",
  "返水": "返水",
  "总投注": "總投注",
  "有效投注": "有效投注",
  "实际盈利": "實際盈利",
  "两面": "兩面",
  "组合": "組合",
  "每页": "每頁",
  "条": "條",
  "编辑金额": "編輯金額",
  "恢复默认": "恢復預設",
  "保存": "儲存",
  "距离开奖": "距離開獎",
  "刷新": "重新整理",
  "返回": "返回",
  "当前第": "目前第",
  "数据统计详情": "數據統計詳情",
  "值": "值",
  "未开期数": "未開期數",
  "单路区": "單路區",
  "间隔": "間隔",
  "咪牌": "咪牌",
  "投注区": "投注區",
  "游戏记录": "遊戲記錄",
  "路单区": "路單區",
  "游戏规则": "遊戲規則",
  "开奖验证": "開獎驗證",
  "开奖记录": "開獎紀錄",
  "统计": "統計",
  "大小": "大小",
  "极大小": "極大小",
  "已选": "已選",
  "注": "註",
  "共计": "共計",
  "已中奖": "已中獎",
  "未开奖": "未開獎",
  "已退款": "已退款",
  "语言": "語言",
  "六合彩": "六合彩",
  "初级": "初級",
  "猜特码": "猜特碼",
  "猜特肖": "猜特肖",
  "猜平肖": "猜平蕭",
  "猜类型": "猜類型",
  "平肖": "平蕭",
  "鼠": "鼠",
  "牛": "牛",
  "虎": "虎",
  "兔": "兔",
  "龙": "龍",
  "蛇": "蛇",
  "马": "馬",
  "羊": "羊",
  "猴": "猴",
  "鸡": "雞",
  "狗": "狗",
  "猪": "豬",
  "类型": "類型",
  "蓝波": "藍波",
  "绿波": "綠波",
  "红波": "紅波",
  "特肖": "特肖",
  "特鼠": "特鼠",
  "特牛": "特牛",
  "特虎": "特虎",
  "特兔": "特兔",
  "特龙": "特龍",
  "特蛇": "特蛇",
  "特马": "特馬",
  "特羊": "特羊",
  "特鸡": "特雞",
  "特狗": "特狗",
  "特猪": "特豬",
  "特猴": "特猴",
  "什么也没有": "什麼也沒有",
  "进行中": "進行中",
  "已结束": "已結束",
  "快捷下注": "快速下注",
  "开奖走势": "開獎走勢",
  "开奖历史": "開獎歷史",
  "在线": "網路",
  "快捷投注": "快速投注",
  "项": "項",
  "需支付": "需支付",
  "确认投注": "確認投注",
  "错误提示": "錯誤提示",
  "管理员": "管理員",
  "封盘中": "封盤中",
  "预计盈利": "預計獲利",
  "投注成功": "投注成功",
  "用户": "使用者",
  "时间": "時間",
  "投注": "投注",
  "MI28": "MI28",
  "中级": "中級",
  "新澳门六合彩": "新澳門六合彩",
  "澳门六合彩": "澳門六合彩",
  "下注内容": "下注內容",
  "合计总金额": "合計總金額",
  "房间": "房間",
  "投注详情": "投注詳情",
  "输赢": "輸贏",
  "开奖结果": "開獎結果",
  "当期总输赢": "當期總輸贏",
  "开奖时间": "開獎時間",
  "更多新玩法等你来体验": "更多新玩法等你來體驗",
  "精彩活动": "精彩活動",
  "代理联盟": "代理商聯盟",
  "始于成功": "始於成功",
  "臻于卓越": "臻於卓越",
  "鲤跃龙门": "鯉躍龍門",
  "投资传奇": "投資傳奇",
  "VIP会员成长": "VIP會員成長",
  "晋级VIP会员": "晉級VIP會員",
  "享顶级至尊服务": "享受頂級至尊服務",
  "确认添加": "確認新增",
  "iOS用户注意": "iOS 用戶注意",
  "充值打码量": "充值打碼量",
  "全部": "全部",
  "划转": "劃轉",
  "协议的区别": "協議的區別",
  "开奖中": "開獎中",
  "新增USDT地址": "新增 USDT 地址",
  "新增银行卡": "新增銀行卡",
  "本月存款": "本月存款",
  "游戏大厅": "遊戲大廳",
  "玩法介绍": "玩法介紹",
  "账户": "帳戶",
  "赠送打码量": "贈送打碼量",
  "搜索游戏名称": "搜尋遊戲名稱",
  "请登录": "請登入",
  "红包已关闭": "紅包已關閉",
  "已在当前页面": "已在目前頁面",
  "马克六号彩票": "馬克六號彩票",
  "PC28高赔率": "MI28高賠率",
  "PC28": "MI28",
  "发送的消息不能为空": "发送的消息不能为空",
  "19:56:30～20:29:30 为维护时间": "19:56:30～20:29:30 为维护时间",
  "23:55:30～00:05:00 为维护时间": "23:55:30～00:05:00 为维护时间",
  "本期已封盘": "本期已封盘",
  "发送成功": "发送成功",
  "请选择玩法": "请选择玩法",
  "请选择金额": "请选择金额",
  "恢复成功": "恢复成功",
  "价格不能为空值或0": "价格不能为空值或0",
  "价格不能有重复": "价格不能有重复",
  "持卡人姓名": "持卡人姓名",
  "请输入持卡人姓名": "请输入持卡人姓名",
  "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致": "为了您的资金能够迅速到账，请确保填写的姓名与银行卡的开户姓名一致",
  "请选择银行类型": "请选择银行类型",
  "请输入开户行": "请输入开户行",
  "请输入姓名": "请输入姓名",
  "请输入银行": "请输入银行",
  "请输人银行卡号": "请输人银行卡号",
  "请输人支付密码": "请输人支付密码",
  "请输人正确的卡号长度": "请输人正确的卡号长度",
  "请输人支付密码长度": "请输人支付密码长度",
  "绑定成功": "绑定成功",
  "USDT地址": "USDT地址",
  "请输入USDT地址": "请输入USDT地址",
  "请选择钱包协议": "请选择钱包协议",
  "赠送记录": "赠送记录",
  "选择开始日期": "选择开始日期",
  "选择结束日期": "选择结束日期",
  "输入账号": "输入账号",
  "昵称": "昵称",
  "赠送前": "赠送前",
  "赠送后": "赠送后",
  "赠送金额": "赠送金额",
  "到账状态": "到账状态",
  "直属代理": "直属代理",
  "自己": "自己",
  "请先选择开始时间": "请先选择开始时间",
  "团队总人数": "团队总人数",
  "团队总彩金": "团队总彩金",
  "团队总充值": "团队总充值",
  "团队总输赢": "团队总输赢",
  "团队总投注": "团队总投注",
  "团队纯利": "团队纯利",
  "团队福利": "团队福利",
  "新注册人数": "新注册人数",
  "首充人数": "首充人数",
  "团队返水": "团队返水",
  "团队拥金返水": "团队拥金返水",
  "六合盈亏": "六合盈亏",
  "金币": "金币",
  "总盈利": "總盈利",
  "直属": "直属",
  "所在房间": "所在房间",
  "代理": "代理",
  "暂无数据": "暂无数据",
  "MI28按照加拿大卑斯快乐8的开奖结果为基础": "MI28按照加拿大卑斯快乐8的开奖结果为基础",
  "每日官网维护时间是18:56-19:33": "每日官网维护时间是18:56-19:33",
  "每3.5分钟公布一次加拿大卑斯快乐8开奖结果": "每3.5分钟公布一次加拿大卑斯快乐8开奖结果",
  "排序后分别按号码": "排序后分别按号码",
  "第1-6，7-12，13-18分为【1】【2】【3】三个区": "第1-6，7-12，13-18分为【1】【2】【3】三个区",
  "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。": "赔率全新升级！ 单注1起，总注500000封顶。大小单双100000封顶。组合50000封顶。",
  "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。": "特码20000封顶。2值10000封顶。 大小单双2.0倍（含本金）。【组合:小单/大双4.6倍；小双/大单4.2倍】（含本金）。",
  "注：大小单双开13/14特殊赔率": "注：大小单双开13/14特殊赔率",
  "总注：4999以内1.6倍（含本金）": "总注：4999以内1.6倍（含本金）",
  "总注：9999以内1.2倍（含本金）": "总注：9999以内1.2倍（含本金）",
  "总注：30000以上吃下注本金": "总注：30000以上吃下注本金",
  "组合：29999以内小单，大双 开13，14赔率回本（含本金）！": "组合：29999以内小单，大双 开13，14赔率回本（含本金）！",
  "组合：30000以上吃下注本金": "组合：30000以上吃下注本金",
  "豹子-顺子-对子-玩法": "豹子-顺子-对子-玩法",
  "豹子48倍": "豹子48倍",
  "顺子10倍": "顺子10倍",
  "对子3倍": "对子3倍",
  "极值15倍": "极值15倍",
  "回水规则": "回水规则",
  "1、负分3600.000-36000.000 需下注把数10吧 反百分之3": "1、负分3600.000-36000.000 需下注把数10吧 反百分之3",
  "2、负分36000.000-100000.000需下注把数10把 反百分之5": "2、负分36000.000-100000.000需下注把数10把 反百分之5",
  "3、负分100000.000需下注把数10把 反百分之8": "3、负分100000.000需下注把数10把 反百分之8",
  "【MI28】规则说明": "【MI28】规则说明",
  "1.大小玩法 数字14-27为大 数字0-13为小 。": "1.大小玩法 数字14-27为大 数字0-13为小 。",
  "2.单双玩法": "2.单双玩法",
  "数字1，3，5，~27为单 数字0，2，4~26为双。": "数字1，3，5，~27为单 数字0，2，4~26为双。",
  "3.极值玩法": "3.极值玩法",
  "极小：0，1，2，3，4，5": "极小：0，1，2，3，4，5",
  "极大：22，23，24，25，26，27": "极大：22，23，24，25，26，27",
  "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。": "举例：买极小 开奖结果为0-5其中一个数字就中奖，买极大开奖结果为22-27其中一个数字就中奖。",
  "4.组合玩法": "4.组合玩法",
  "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。": "* 数字14，16，~26为大双； 数字0，2，4，~12为小双。",
  "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。": "* 数字15，17，~27为大单； 数字1，3，5，~13为小单。",
  "5.定位玩法(单点数字玩法)": "5.定位玩法(单点数字玩法)",
  "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。": "从数字0-27中选取一个数字下注，如选取下注的数字与开奖如果相同，即为中奖。",
  "6.波色": "6.波色",
  "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25": "* 绿波号码：1 , 4 , 7 , 10 , 16 , 19 , 22 , 25",
  "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26": "* 蓝波号码：2 , 5 , 8 , 11 , 17 , 20 , 23 , 26",
  "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24": "* 红波号码：3 , 6 , 9 , 12 , 15 , 18 , 21 , 24",
  "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！": "* 当开奖结果为：0,13,14,27(所有买的波色皆输)视为全部不中奖！",
  "7.豹子  顺子  对子": "7.豹子  顺子  对子",
  "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。": "当期3个开奖号码一致则中奖 , 如当期开奖结果为 3+3+3=9 则中奖豹子。",
  "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。": "当期3个开奖号码顺子则中奖，如当期开奖结果为 1+2+3=6 则中奖顺子。",
  "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。": "当期3个开奖号码有两个一致中奖，如当期开奖结果为 0+2+2=4 则中奖对子。",
  "已经是最后一页啦！": "已经是最后一页啦！",
  "用户名长度6~16位，以字母或数字组合！": "用户名长度6~16位，以字母或数字组合！",
  "请输入正确的密码长度，最少6位！": "请输入正确的密码长度，最少6位！",
  "密码错误，请重新输入": "密码错误，请重新输入",
  "账户登录": "账户登录",
  "请输入账号": "请输入账号",
  "验证码": "验证码",
  "记住密码": "记住密码",
  "跳过登录，先去逛逛": "跳过登录，先去逛逛",
  "新用户注册": "新用户注册",
  "请输入短信验证码": "请输入短信验证码",
  "获取验证码": "获取验证码",
  "切换线路": "切换线路",
  "请输入您的账号和密码！": "请输入您的账号和密码！",
  "OB电子": "OB电子",
  "FG电子": "FG电子",
  "PP电子": "PP电子",
  "AE电子": "AE电子",
  "始": "始",
  "开": "开",
  "包": "包",
  "红": "红",
  "离": "离",
  "距": "距",
  "束": "束",
  "结": "结",
  "完": "完",
  "抢": "抢",
  "已": "已",
  "已领取": "已领取",
  "当前最多可领取": "当前最多可领取",
  "快去满足条件吧！": "快去满足条件吧！",
  "活动时间": "活动时间",
  "累计充值金额": "累计充值金额",
  "红包次数": "红包次数",
  "领取规则": "领取规则",
  "抢到红包后，系统自动派彩，": "抢到红包后，系统自动派彩，",
  "秒到账": "秒到账",
  "，达到流水倍数即可取款；": "，达到流水倍数即可取款；",
  "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；": "2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；",
  "南宫集团官网": "南宫集团官网",
  "注意": "注意",
  "抢红包": "抢红包",
  "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~": "北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~",
  "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！": "每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！",
  "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！": "1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！",
  "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。": "2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。",
  "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。": "3、金沙集团官网保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。",
  "当前时间段": "当前时间段",
  "活动还没开始，请静待活动开始。": "活动还没开始，请静待活动开始。",
  "请静待下次活动。": "请静待下次活动。",
  "恭喜您": "恭喜您",
  "抢到": "抢到",
  "立即充值": "立即充值",
  "您暂未达到领取条件，快去完成吧！": "您暂未达到领取条件，快去完成吧！",
  "服务器异常，请稍后再试": "服务器异常，请稍后再试",
  "软件APP": "软件APP",
  "按照": "按照",
  "到您的桌面": "到您的桌面",
  "安装": "安装",
  "请先登录": "请先登录",
  "PC彩票": "PC彩票",
  "万美元": "万美元",
  "现在就成为赢家": "现在就成为赢家",
  "开始": "开始",
  "最新投注": "最新投注",
  "最新": "最新",
  "日榜": "日榜",
  "周榜": "週榜",
  "月榜": "月榜",
  "经典": "經典",
  "百家乐": "百家樂",
  "快速": "快速",
  "大富翁": "大富翁",
  "财神驾到": "財神駕到",
  "红包派对": "紅包派對",
  "沙巴体育": "沙巴體育",
  "UP体育": "UP體育",
  "德州扑克": "德州撲克",
  "21点": "21點",
  "抢庄牛牛": "搶莊牛牛",
  "巴沙体育": "巴沙體育",
  "游戏": "游戏",
  "玩家": "玩家",
  "倍数": "倍数",
  "返奖": "返奖",
  "更多": "更多",
  "热门": "热门",
  "即将上线，敬请期待": "即将上线，敬请期待",
  "立即投注": "立即投注",
  "游戏厂商": "游戏厂商",
  "183款游戏": "183款游戏",
  "千人在线畅玩": "千人在线畅玩",
  "最佳加密货币赌场 - 欢迎来到": "最佳加密货币赌场 - 欢迎来到",
  "home-detail-content": "探索加密遊戲的終極目的地，這裡每一筆交易都透明公開，每一款遊戲都可驗證公平性。• MI28 娛樂城致力於為每位用戶提供安全、可靠、公平的遊戲環境。",
  "收起更多": "收起更多",
  "查看更多": "查看更多",
  "支持/法律": "支持/法律",
  "常见问题": "常见问题",
  "负责任博彩": "负责任博彩",
  "公平公正": "公平公正",
  "服务条款": "服务条款",
  "隐私政策": "隐私政策",
  "关于我们": "关于我们",
  "支持的币种": "支持的币种",
  "赞助和博彩责任": "赞助和博彩责任",
  "introduce1": "MI28 由BETMGM LLC持有及營運，該公司在美國特拉華州註冊，公司編號7061304，註冊地址：美國新澤西州大西洋城的Marina District，依託美高梅度假村的線下資源開展線上業務。",
  "introduce2": "BetMGM在多個美國合規州及海外地區持有官方博彩營運牌照，部分公開可查的核心牌照如下",
  "introduce3": "新澤西州：由新澤西州博彩執法局頒發，許可證編號為NJIGP 000105-001，是其最早獲得的核心營運牌照之一",
  "introduce4": "內華達州：由內華達州博彩控制委員會頒發，持有體育博彩全資質牌照",
  "introduce5": "英國：獲得英國博彩委員會（UK Gambling Commission）頒發的遠程博彩牌照，牌照編號為042596",
  "introduce6": "MI28致力於為所有用戶提供安全、可靠、公平的遊戲環境。無論是下注、玩老虎機，還是參與真人或其他遊戲活動，您都可以放心，MI28堅持誠信運營，為每位玩家提供卓越的遊戲體驗。",
  "尊敬的NG娱乐会员:": "尊敬的NG娱乐会员:",
  "我知道了": "我知道了",
  "如何安装": "如何安装",
  "1、使用Safar浏览器打开网站": "1、使用Safar浏览器打开网站",
  "2、点击分享图标": "2、点击分享图标",
  "3、选择“添加到主屏幕”": "3、选择“添加到主屏幕”",
  "添加到主屏幕": "添加到主屏幕",
  "期开奖": "期开奖",
  "账户余额": "账户余额",
  "封盘中禁止投注": "封盘中禁止投注",
  "请输入文字指令下注": "请输入文字指令下注",
  "发送": "发送",
  "信用投注": "信用投注",
  "共": "共",
  "合计": "合计",
  "最近投注": "最近投注",
  "投注确认": "投注确认",
  "游戏平台": "游戏平台",
  "免转模式": "免转模式",
  "额度转换": "额度转换",
  "平台账户余额": "平台账户余额",
  "游戏账户余额": "游戏账户余额",
  "操作金额": "操作金额",
  "填写操作金额": "填写操作金额",
  "转账方式": "转账方式",
  "提交": "提交",
  "充值信息": "充值信息",
  "请在": "请在",
  "内完成支付": "内完成支付",
  "成功付款后，将自动到账！": "成功付款后，将自动到账！",
  "如有问题，请": "如有问题，请",
  "确认": "确认",
  "收款地址": "收款地址",
  "交易时间": "交易时间",
  "充值方式": "充值方式",
  "充值完成": "充值完成",
  "资金明细": "资金明细",
  "支付方式": "支付方式",
  "银行卡": "银行卡",
  "余额充值": "余额充值",
  "请输入充值金额": "请输入充值金额",
  "充值限额：": "充值限额：",
  "请设置密码": "请设置密码",
  "注册并下载APP": "注册并下载APP",
  "两次密码不一样！": "两次密码不一样！",
  "请输入验证码！": "请输入验证码！",
  "验证码错误！": "验证码错误！",
  "注册失败": "注册失败",
  "获取验证码...": "获取验证码...",
  "请阅读并同意相关条款和隐私协议！": "请阅读并同意相关条款和隐私协议！",
  "两次密码不一致！": "两次密码不一致！",
  "请输入您的真实姓名!": "请输入您的真实姓名!",
  "请输入正确的支付密码长度，最少6位！": "请输入正确的支付密码长度，最少6位！",
  "卡片管理": "卡片管理",
  "虚拟币": "虚拟币",
  "最多支持添加5张银行卡": "最多支持添加5张银行卡",
  "确定要解除绑定该卡片吗？": "确定要解除绑定该卡片吗？",
  "解绑成功": "解绑成功",

  "(几分钟到数十分钟)": "(几分钟到数十分钟)",
  "(几秒到几分钟)": "(几秒到几分钟)",
  "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！": "*两种协议对应的USDT地址不互通，进行转账、充值等操作时，应仔细核对正确地址！",
  "1. 点击我的 (个人信息)": "1. 点击我的 (个人信息)",
  "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：": "1.第一次提现到数字货币时，请先绑定提币地址，绑定提币地址的步骤：",
  "1.请注意，注册时要求填写真实而准确的信息。": "1.请注意，注册时要求填写真实而准确的信息。",
  "2. 卡片管理": "2. 卡片管理",
  "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。": "2.用户使用网站前，请务必先阅读规则与条款，并确定已年满18岁。",
  "2.输入提币金额，点击‘立即取款’，提币申请提交成功": "2.输入提币金额，点击‘立即取款’，提币申请提交成功",
  "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。": "2007-08赛季，尼克·杨代表奇才队出战75场常规赛比赛，场均得到7.5分、1.5个篮板。",
  "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。": "2007年NBA选秀，尼克·杨在第一轮第16顺位被华盛顿奇才队选中。",
  "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。": "2008-09赛季，由于奇才后场大将吉尔伯特·阿里纳斯的报销，尼克·杨获得了更多的机会，出战82场首发5次，场均得到10.9分。",
  "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分": "2009-10赛季，奇才后场补充了兰迪·弗耶、迈克·米勒等优秀球员，抢占了尼克·杨的出场时间，尼克·杨出战74场比赛，场均得到8.6分",
  "3. 添加虚拟币地址": "3. 添加虚拟币地址",
  "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额": "3.提币审核成功后请登录交易网站或数字货币官方网站核实到账金额",
  "4. 填写虚拟币地址信息": "4. 填写虚拟币地址信息",
  "5. 选择虚拟币提现/立即取款": "5. 选择虚拟币提现/立即取款",
  "6. 等待审核": "6. 等待审核",
  "ERC20-USDT地址以0x开头": "ERC20-USDT地址以0x开头",
  "ERC20协议": "ERC20协议",
  "ERC20：基于以太坊网络协议": "ERC20：基于以太坊网络协议",
  "Hi，欢迎进入{title}": "Hi，欢迎进入{title}",
  "TRC20-USDT地址以T开头": "TRC20-USDT地址以T开头",
  "TRC20协议": "TRC20协议",
  "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。": "TRC20的提币手续费最低，这意味着用户可以享受低手续费的交易所提币服务。同时，波场网络的TPS能够达到上千级别，可以实现交易秒级确认。",
  "TRC20：基于波场网络协议": "TRC20：基于波场网络协议",
  "Luka赞助内容": "sponsor_luka_content",
  "专属VIP体验": "专属VIP体验",
  "个人简介": "个人简介",
  "中等额度": "中等额度",
  "中等额度推荐": "中等额度推荐",
  "交易推荐": "交易推荐",
  "交易记录": "交易记录",
  "享受只属于你的与众不同": "享受只属于你的与众不同",
  "今日收益": "今日收益",
  "代理加盟": "代理加盟",
  "代理登录": "代理登录",
  "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。": "以太坊发行自己的原生代币及其他代币。但成千上万种代币的规则都不一样，这对后期市场发展非常不利。所以代币发行者做了一个智能合约标准，也就是ERC20。",
  "以太坊网络": "以太坊网络",
  "会员中心": "会员中心",
  "会员教程": "会员教程",
  "低": "低",
  "低手续费，秒级到账。": "低手续费，秒级到账。",
  "体育游戏规则": "体育游戏规则",
  "使用建议": "使用建议",
  "使用网络": "使用网络",
  "充值前": "充值前",
  "充值后": "充值后",
  "充值教程": "充值教程",
  "充值时间": "充值时间",
  "充值金额": "充值金额",
  "免责说明": "免责说明",
  "分享链接": "分享链接",
  "到底选哪种协议更好？": "到底选哪种协议更好？",
  "前往领取": "前往领取",
  "加入{title}第{days}天": "加入{title}第{days}天",
  "加入我们，共赢财富": "加入我们，共赢财富",
  "区别点": "区别点",
  "协议介绍": "协议介绍",
  "博彩责任": "博彩责任",
  "历史收益": "历史收益",
  "地址样式": "地址样式",
  "场馆余额": "场馆余额",
  "基本不堵": "基本不堵",
  "复制成功！": "复制成功！",
  "好友接受": "好友接受",
  "好友进行": "好友进行",
  "如何注册": "如何注册",
  "存款投注": "存款投注",
  "安全系数": "安全系数",
  "安全退出": "安全退出",
  "官方全球顶级合作伙伴": "官方全球顶级合作伙伴",
  "官方区域合作伙伴": "官方区域合作伙伴",
  "尊敬的会员用户": "尊敬的会员用户",
  "小额交易推荐": "小额交易推荐",
  "小额高频": "小额高频",
  "尤文图斯": "尤文图斯",
  "已领取次数": "已领取次数",
  "帮助中心": "帮助中心",
  "常规交易推荐": "常规交易推荐",
  "彩票投注规则": "彩票投注规则",
  "得分": "得分",
  "得分：{score}": "得分：{score}",
  "总投注额": "总投注额",
  "总资产": "总资产",
  "您的邀请": "您的邀请",
  "意见反馈": "意见反馈",
  "手机号码注册": "手机号码注册",
  "手机号码注册-输入手机号码，并验证码手机号码。": "手机号码注册-输入手机号码，并验证码手机号码。",
  "手续费和速度都介于中间值。": "手续费和速度都介于中间值。",
  "手续费用": "手续费用",
  "投注前": "投注前",
  "投注后": "投注后",
  "捕鱼": "捕鱼",
  "提现前，请先确保您已成功登录账号。": "提现前，请先确保您已成功登录账号。",
  "提现教程": "提现教程",
  "早上好，欢迎来到帮助中心": "早上好，欢迎来到帮助中心",
  "时间排行榜": "时间排行榜",
  "时间：{time}": "时间：{time}",
  "普通": "普通",
  "更多公告": "更多公告",
  "有效流水": "有效流水",
  "期数": "期数",
  "未登录": "未登录",
  "条款协议内容": "条款协议内容",
  "极快": "极快",
  "欢迎来到{title}": "欢迎来到{title}",
  "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌": "欢迎来到平台，我们致力于通过精良的技术、前卫的产品，成为亚洲博彩业的领导品牌",
  "步骤如下": "步骤如下",
  "永久域名": "永久域名",
  "没有找到解决办法？请联系": "没有找到解决办法？请联系",
  "波场网络": "波场网络",
  "活动时间: 长期有效": "活动时间: 长期有效",
  "活动记录": "活动记录",
  "游戏排行榜": "游戏排行榜",
  "游戏规则_体育内容": "<div class=\"sports-games-article\"><div class=\"main-container-title\">一般体育规则</div><div class=\"main-container-content\"><p>所有投注须遵守平台规则与条款，请在投注前查看具体玩法。赛事取消或延期时，注单将按对应规则处理。</p><ol><li>提交前请仔细检查投注选项。</li><li>投注提交后不可修改或取消。</li><li>官方赛果和平台记录作为结算依据。</li><li>滚球遇到重大事件时可能延迟确认或拒绝。</li></ol></div></div>",
  "游戏规则_彩票内容": "<div class=\"lottery-games-article\"><div class=\"main-container-title\">彩票投注规则</div><div class=\"main-container-content\"><p>彩票玩法以官方开奖结果结算，请在投注前查看玩法定义、封盘时间和赔付条件。</p><p>取消、延期或无效开奖按对应玩法规则处理。</p></div></div>",
  "游戏规则_电子游戏内容": "<div class=\"electron-games-article\"><div class=\"main-container-title\">电子游戏规则</div><div class=\"main-container-content\"><p>{brand}电子游戏使用经认证的随机结果，请理性娱乐并在投注前查看赔付表。</p><p>赛果按照页面展示规则和平台记录结算。</p></div></div>",
  "游戏规则_真人内容": "<div class=\"immortal-games-article\"><div class=\"main-container-title\">真人娱乐规则</div><div class=\"main-container-content\"><p>轮盘、百家乐和骰宝由真人荷官主持。请选择玩法，在封盘前提交投注并等待官方赛果。</p><p>各桌的规则、赔率和结算条件以页面展示为准。</p></div></div>",
  "电子游戏规则": "电子游戏规则",
  "登录后查看": "登录后查看",
  "登录平台-个人信息-卡片管理-添加数字货币地址": "登录平台-个人信息-卡片管理-添加数字货币地址",
  "真人娱乐规则": "真人娱乐规则",
  "真人娱乐，体育投注，电子游艺等尽在一手掌握": "真人娱乐，体育投注，电子游艺等尽在一手掌握",
  "福利中心": "福利中心",
  "立享会员特权": "立享会员特权",
  "立即登录": "立即登录",
  "第一步：在网站或App上直接点击注册；": "第一步：在网站或App上直接点击注册；",
  "第三步：按照提示填写资料；": "第三步：按照提示填写资料；",
  "第三步：设置账户昵称": "第三步：设置账户昵称",
  "第二步：按照提示填写资料；": "第二步：按照提示填写资料；",
  "第二步：按照提示填写资料；；": "第二步：按照提示填写资料；；",
  "第五步：注册成功。": "第五步：注册成功。",
  "第四步：注册成功": "第四步：注册成功",
  "第四步：设置账户昵称。": "第四步：设置账户昵称。",
  "等级": "等级",
  "等级排行榜": "等级排行榜",
  "等级：{level}": "等级：{level}",
  "红包记录": "红包记录",
  "红包金额": "红包金额",
  "经常拥堵": "经常拥堵",
  "给你好友": "给你好友",
  "网络状态": "网络状态",
  "联系我们": "联系我们",
  "至": "至",
  "若相关问题仍未解决，可咨询在线客服": "若相关问题仍未解决，可咨询在线客服",
  "虚拟币提现": "虚拟币提现",
  "虚拟币支付": "虚拟币支付",
  "设置登录密码。": "设置登录密码。",
  "豪礼赠送": "豪礼赠送",
  "账户名注册": "账户名注册",
  "账户名注册-输入账户名和密码。。": "账户名注册-输入账户名和密码。。",
  "账户设置": "账户设置",
  "购买虚拟币": "购买虚拟币",
  "赞助": "赞助",
  "赞助信息": "赞助信息",
  "转账速度": "转账速度",
  "退出系统": "退出系统",
  "选择数字货币": "选择数字货币",
  "邀请有好礼 红包等你": "邀请有好礼 红包等你",
  "阿斯顿维拉": "阿斯顿维拉",
  "隐私政策提示": "隐私政策提示",
  "高": "高",
  "1. 打开并登录欧意APP": "1. 打开并登录欧意APP",
  "1. 选择数字货币": "1. 选择数字货币",
  "2. 输入充值金额": "2. 输入充值金额",
  "2. 选择快捷买币": "2. 选择快捷买币",
  "3. 复制地址或进行扫码": "3. 复制地址或进行扫码",
  "3. 点击去购买": "3. 点击去购买",
  "4. 打开并登录欧易软件": "4. 打开并登录欧易软件",
  "4. 输入购买金额": "4. 输入购买金额",
  "5. 可持续二次购买": "5. 可持续二次购买",
  "5. 进入“资金”选择“提现”": "5. 进入“资金”选择“提现”",
  "6. 选择USDT币种": "6. 选择USDT币种",
  "7. 点击提交按钮": "7. 点击提交按钮",
  "VIP收益": "VIP收益",
  "参与期数": "参与期数",
  "团队俑金返水": "团队俑金返水",
  "团队彩金": "团队彩金",
  "团队总剩余": "团队总剩余",
  "团队总提现": "团队总提现",
  "团队总流水": "团队总流水",
  "团队总盈利": "团队总盈利",
  "团队退水": "团队退水",
  "当前游戏无房间": "当前游戏无房间",
  "条款与规则": "条款与规则",
  "消息": "消息",
  "玩家详情": "玩家详情",
  "虚拟货币支付": "虚拟货币支付",
  "返点收益": "返点收益",
  "香港六合彩": "香港六合彩",
  "AG真人": "AG Casino",
  "AG电子": "AG Electronic",
  "BG真人": "BG Casino",
  "FB体育": "FB Sports",
  "KY棋牌": "KY Chess",
  "PG电子": "PG Slots",
  "专业模式": "专业模式",
  "群控模式": "群控模式",
  "进入游戏": "进入游戏",
  "大厅选择": "大廳選擇",
  "选择房间": "選擇房間",
  "房间规则": "房間規則",
  "新手推荐": "新手推薦",
  "最热门": "最熱門",
  "VIP专属": "VIP專屬",
  "MI28-中级": "MI28-中級",
  "MI28-高级": "MI28-高級",
  "MI28-5分钟": "MI28-5分鐘",
  "MI28-5分钟-中级": "MI28-5分鐘-中級",
  "MI28-5分钟-高级": "MI28-5分鐘-高級",
  "房间规则1": "1.VIP1廳適合新手入門體驗",
  "房间规则2": "2.VIP2廳賠率更高，適合進階玩家",
  "房间规则3": "3.VIP3廳享受最高賠率和專屬服務",
  "分钟": "分鐘",
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-TW.js